import React from 'react';

import * as hf from './_hf';
import * as ht from './_ht';
import * as f from './_cmFTH';
import * as cr from './_cr';
import * as gs from './_csGbl';

import * as l from "./_csLcl";
import { a } from "./_csAbt";
import { useMsgz } from "./_csMdlMsg";

import * as BtnC from './_cccBtnC';
import * as BtnCttC from './_ccmBtnCttC';
import * as TblC from "./_ccmTblC";
import * as TextC from "./_ccbTextC";
import * as BoxC from './_ccbBoxC';
import * as GridC from './_cccGridC';
import * as IptC from './_ccbIptC';
import * as LblC from './_cccLblC';

import * as ica from 'src/ica';

import * as _cv_40 from './_cv_40___Mz';
import * as _cv_41 from './_cv_41___Mz';

let $_41z = _cv_41.itl_41z();

let $_40rs = [] as ht.ls;

export const B = (pz: ht.btnCttCz) => {
  const _sMsgz = useMsgz();
  return (
    cr.c(BtnCttC.N, {
      key: -10,
      sPz: pz.sPz,
      cz: {
        lblz: pz.cz.lblz,
        sc: pz.cz.sc,
        ugdAsync: async () => {
          const __41rz = $_41z._41rz;
          const _b = await hf.ectSrlAsync([
            async () => { // 必須項目の確認
              let _b = true;
              if (
                !hf.f(__41rz._icn) || // 部屋ID
                !hf.f(__41rz._pfx) // 部屋名
              ) _b = false;
              if (!_b) {
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: '必須項目が入力されていないため、指定された操作を行うことができません',
                    }
                  }
                })
              }
              return _b;
            },
          ])
          if (_b) {
            const _41z = await _cv_41.save_41rDzAsync({
              ... pz,
              _41z: $_41z,
            });
            return {
              _41r_fst: _41z._41rz._fst,
            }
          }

        },
      }
    })
  );
};

export const D = (pz: ht.viewDtlCz) => {

  const _gUserz = gs.useUserz();

  const _frcUdt = l.frcUdt();

  React.useEffect(() => {
    f.loadAllAsync({
      phs: pz.sPz.crt.phs,
      frcUdt: _frcUdt,
      bfrAsync: () => [
        _cv_40.load_40rLsAsync()
        .then((_ls: ht.ls) => {
          $_40rs = _ls.filter((_dz: ht.dz) => {
            if (
              (_dz._icn == '2z711' && _gUserz.crt.i19rz?.i19ra2210i != 1) || // 備品・駐車場
              (_dz._icn == '19111' && _gUserz.crt.i19rz?.i19ra2110i != 1) // メール送信
            ) {
              return false;
            }
            else {
              return true;
            }
          });
        })
      ],
      crtAsync: () => [
        _cv_41.crt_41z()
        .then((_dz: ht.dz) => {
          $_41z = _dz;
        })
      ],
      udtAsync: () => [
        _cv_41.load_41rDzAsync({
          _41r_fst: pz.sPz.crt._41r_fst,
          cdn: 'true',
          vsn: pz.sPz.crt.vsn,
        })
        .then((_dz: ht.dz) => {
          $_41z = _dz;
        })
      ]
    });
  }, [
    pz.sPz.crt.phs,
    pz.sPz.crt._41r_fst,
    pz.sPz.crt.vsn,
  ])

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewDtlAbtz[_abtType] ? ica.viewDtlAbtz[_abtType]() : {};

  const _hdrs = [] as ht.ls;

  _hdrs.push({
    cellCs: [
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
//            abtType: 'lblStfz',
            ... _abtz.cldz.hdrCz.textCz,
            textz: {
              pfx: '操作を許可する項目'
            }
          })
        ]
      },
    ],
  });

  const _bdys = [] as ht.ls;
  $_41z?._411s
  .filter( ( _411z:ht.dz ) => _411z._dlt != 1 )
  .map( ( _411z:ht.dz ) => {
    _bdys.push({
      cellCs: [
        {
          oClds: [
            cr.c(IptC.S, {
              key: -10,
              cz: {
                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                iptType: 'pcr',
                vle: _411z._411_40r1k ?? -1,
                ls: $_40rs,
                onChg: ( _dz: ht.dz ) => {
                  _411z._411_40r1k = _dz.key;
                }
              }
            })
          ]
        },
        {
          boxStlz: a('dw/10 f/n'),
          oClds: [
            hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ?
            cr.c(BtnC.N, {
              key: -10,
              ... _abtz.cldz.bdyCz.btnDltCz,
              bfrIconCz: {},
              lblCz: {},
              pslPtyz: {
                onPress: () => {
                  _411z._dlt = 1;
                  _frcUdt();
                },
              }
            })
            : null,
          ]
        },
      ],
    });
  });
  
  if ( hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ) {
    _bdys.push({
      cellCs: [
        {
          oClds: [
            cr.c(BtnC.N, {
              key: -10,
              ... _abtz.cldz.bdyCz.btnAddCz,
              bfrIconCz: {},
              lblCz: {},
              pslPtyz: {
                onPress: () => {
                  $_41z?._411s.push({
                    _key: -1,
                    _dlt: -1,
                    _411_41r1k: pz.sPz.crt._key,
                    _411_40r1k: -1,
                  });
                  _frcUdt();
                },
              }
            })
          ]
        },
      ],
    });
  }

  return (
    cr.c(BoxC.N, {
      key: -10,
      boxStlz: a('dw/f fd/csc'),
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'nolineCmnz',
          boxStlz: a('dwx/60 mb/2 mh/a'),
          lineCs: [
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/14`),
                        textz: {
                          pfx: '権限分類ID：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $_41z?._41rz._icn ?? '',
                              onChg: ( _s: ht.s ) => {
                                $_41z._41rz._icn = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/14`),
                        textz: {
                          pfx: '権限分類名：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $_41z?._41rz._pfx ?? '',
                              onChg: ( _s: ht.s ) => {
                                $_41z._41rz._pfx = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
          ]
        }),

        cr.c(TblC.N, {
          key: -20,
          ... _abtz.cldz.tblCz,
          srlCz: {
            srlStlz: {
              otrz: a('dwx/50'),
            }
          },
          hdrCz: {
            lineCs: _hdrs
          },
          bdyCz: {
            lineCs: _bdys
          }
        })

      ]
    })
  );
};

